import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ThreatGroupTooltipsStyled,
  ThreatGroupTooltipsDescription,
  ThreatGroupTooltipsBullet,
  ThreatGroupTooltipsBullets,
} from '../ThreatGroupToolTip.styled'

export const MarketingOptimizationRules = () => {
  const { t } = useTranslation('PMDashboard')
  return (
    <ThreatGroupTooltipsStyled>
      <ThreatGroupTooltipsDescription>
        {t('threatGroups.tooltips.marketingOptimization.description')}
      </ThreatGroupTooltipsDescription>
      <ThreatGroupTooltipsBullets>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.marketingOptimization.frequency_capping')}
        </ThreatGroupTooltipsBullet>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.marketingOptimization.out_of_geo')}
        </ThreatGroupTooltipsBullet>
      </ThreatGroupTooltipsBullets>
    </ThreatGroupTooltipsStyled>
  )
}
